// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3oxXX","box":"WorkspacesBox_box__1d71a","node":"WorkspacesBox_node__2yP-o"};